import { registerCrudStore } from '@/libs/core/+state/register-crud-store';
import { AuditEscalationGroupModel } from '@/libs/Api';
import { AuditEscalationGroupsDataService } from '@/libs/audit-escalation-groups/audit-escalation-groups-data-service';
import { BusinessModule } from '@/libs/core/models/business-module';

export const auditEscalationGroupsStore = registerCrudStore<AuditEscalationGroupModel, AuditEscalationGroupModel>(
    BusinessModule.AuditEscalationGroup,
    new AuditEscalationGroupsDataService()
);
